import axios from "axios";
import { OCTADESK_API, MOTOR_API } from "./octadesk-host";

export default function api() {
  axios.create({
    baseURL: `${OCTADESK_API}/login`,
  })
};

export const enviar = async (assunto, mensagem, token, subcategoria, quantidade, urlAnexo, idResponsavel, idGroupAssigned, squad, fileName, emailsCopia, userRequest) => {
  try {

    let data = {
      "requester": {
        "email": userRequest.email,
        "name": userRequest.name,
        "id": userRequest.idRequester
      },

      "summary": assunto,
      "idSubject": subcategoria?.id,
      "idForm": subcategoria?.idForm || "6d7ce742-8916-4286-bac3-7657efa12259",
      ...(idGroupAssigned ? { "idGroupAssigned": idGroupAssigned } : { "idGroupAssigned": "b7b24fff-d1f4-483e-b277-c8ded87a443b" }),
      ...(idResponsavel ? { "idAssigned": idResponsavel } : {}),

      "cc": emailsCopia || [],
      "comments": {
        "description": {
          "content": mensagem,
          "attachments": urlAnexo ? [{
            "url": urlAnexo,
            "name": fileName
          }] : []
        },

      },
      "customField": {
        ...(subcategoria?.customField || {}),
        ...(quantidade ? { quantidade_de_sku: quantidade } : {}),
        ...(squad ? { squad } : {})
      },

    };

    let response = await axios({
      url: `${OCTADESK_API}/tickets/`,
      method: 'post',
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      data: data
    });


    return response.data;

  } catch (error) {
    if (error.response) {
      console.error("API Error:", error.response.status, error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error setting up request:", error.message);
    }
    throw new Error("Falha ao criar o ticket.");
  }

}

/**
 * 🚪 A PORTA DO CLIENTE NO NOSSO MOTOR (04/09/2026).
 *
 * Substitui o `enviar()` acima **para o formulário do cliente**. O `enviar()`
 * continua existindo e continua indo para a Octadesk porque o
 * `forms_gestores` (organização "Hubsales", gente interna) ainda o usa — e a
 * rota do motor recusa e-mail interno de propósito: chamado aberto por lá
 * nasceria em nome do cliente.
 *
 * O que este envio NÃO carrega, e por quê:
 *
 * • `idResponsavel` / `idGroupAssigned` — o formulário decide isso hoje num
 *   monte de `if` por categoria, apontando para ids de agente da Octadesk.
 *   O motor roteia pela árvore dele (`categorias.area` →
 *   `responsaveis` → `areas.responsavel_padrao`), que é a mesma regra da fila
 *   interna. Mandar o id de lá seria mandar um nome que não existe aqui.
 *
 * • `squad` — não se usa mais squad, é área (decisão de 02/09).
 *
 * • `emailsCopia` (CC) — o motor ainda não tem campo de cópia. Fica anotado
 *   como sobra no projeto; silenciar seria pior, então vai no corpo do texto.
 *
 * 📎 O arquivo vai na MESMA requisição (multipart), não numa segunda chamada:
 * rota separada de anexo precisaria autorizar de novo, e a única credencial
 * aqui é um e-mail.
 */
export const enviarNoMotor = async ({ assunto, mensagem, subcategoria, categoria,
                                      arquivo, emailsCopia, userRequest, quantidade }) => {
  const corpo = new FormData();
  corpo.append("email", (userRequest && userRequest.email) || "");
  corpo.append("assunto", assunto || "");

  // O CC entra no texto enquanto não há campo próprio — quem atende precisa
  // saber quem o cliente queria em cópia, mesmo sem podermos copiar ainda.
  const cc = Array.isArray(emailsCopia) && emailsCopia.length
    ? "\n\nEm cópia (pedido pelo cliente): " + emailsCopia.join(", ")
    : "";
  // A quantidade de SKUs é campo que o cliente DIGITA e ia no `customField`
  // da Octadesk. O motor ainda não tem campo próprio, então vai no texto —
  // sumir em silêncio seria perder informação que ele se deu ao trabalho de dar.
  const qtd = quantidade ? "\n\nQuantidade de SKUs: " + quantidade : "";
  corpo.append("descricao", (mensagem || "") + qtd + cc);

  // 🔑 a subcategoria viaja como o id DA OCTADESK e o motor traduz pelo
  // de/para que já tinha (`categorias.octadesk_id`, 42 de 42 preenchidas).
  // Mandar o id em vez do texto evita casar string com acento e caixa.
  if (subcategoria && subcategoria.id) corpo.append("idSubject", subcategoria.id);
  if (subcategoria && subcategoria.nome) corpo.append("subcategoria", subcategoria.nome);
  if (categoria) corpo.append("categoria", categoria);
  if (arquivo) corpo.append("arquivo", arquivo);

  // ⚠️ SEM `Content-Type` à mão: o browser precisa pôr o boundary do multipart
  // sozinho. Fixar "multipart/form-data" aqui quebra o parse no servidor sem
  // dizer por quê.
  // (04/09, noite) a porta exige a CONTA do cliente: o e-mail sai do token,
  // o `email` do corpo é ignorado pelo servidor.
  const r = await axios({
    url: `${MOTOR_API}/publico/chamados`, method: "post", data: corpo,
    headers: { Authorization: "Bearer " + sessionStorage.getItem("token") }
  });

  // A tela lia `.number` (da Octadesk); o nosso devolve `.id`. Os dois nomes
  // voltam para nada quebrar por causa do rótulo.
  const d = (r.data && r.data.data) || {};
  return { ...d, number: d.id };
};

export const upload = async (data, token) => {
  try {

    return await axios(
      {
        url: `${OCTADESK_API}/tickets/attachments/upload`,
        method: 'POST',
        headers: {
          "accept": "application/json",
          "Content-Type": "multipart/form-data",
          "Authorization": 'Bearer ' + token,

        },
        data: data
      }
    )

  } catch (error) {
    console.log({ erro: "metodo enviar", mensagem: error })
  }
}


export const personEmail = async (email, token) => {
  try {

    return await axios(
      {
        url: `https://octadesk.hubsai.com.br/service/organizacao/${email}`,
        method: 'GET',
        headers: {
          "accept": "application/json",
          "Content-Type": "multipart/form-data",
          "Authorization": 'Bearer ' + token,

        }
      }
    )


  } catch (error) {
    console.log({ erro: "metodo enviar", mensagem: error })
  }
}

export const getOrgId = async (id, token) => {
  try {

    let response = await axios(
      {
        url: `${OCTADESK_API}/organizations/${id}`,
        method: 'GET',
        headers: {
          "accept": "application/json",
          "Content-Type": "multipart/form-data",
          "Authorization": 'Bearer ' + token,

        }
      }
    )

    if (response.data.customField.email_hubsales) {
      let responsavel = await personEmail(response.data.customField.email_hubsales, token)

      sessionStorage.setItem('responsavel', responsavel.data.id || null)
      sessionStorage.setItem('idGroupAssigned', responsavel.data.groups && responsavel.data.groups.length > 0 ? responsavel.data.groups[0].id : null)
      sessionStorage.setItem('squad', response.data.customField ? response.data.customField.squad : null)
    }


  } catch (error) {
    console.log({ erro: "metodo getOrgId", mensagem: error })
  }
}

export const listaTickets = async (id, token, page, rowsPerPage) => {
  try {

    let response = await axios(
      {
        url: `${OCTADESK_API}/tickets/search?idOrganization=${id}&status=!rejeitado|!cancelado&take=${rowsPerPage}&page=${page}`,
        method: 'GET',
        headers: {
          "accept": "application/json",
          "Content-Type": "multipart/form-data",
          "Authorization": 'Bearer ' + token,

        },
        header: 'User-Agent: insomnia/2023.5.8'
      }
    )

    if (response.data) {
      return response.data
    } else {
      return null
    }



  } catch (error) {
    console.log({ erro: "metodo enviar", mensagem: error })
  }
}
